import RequestQuoteIcon from '@mui/icons-material/RequestQuote';

const icons = {
    RequestQuoteIcon
};

const invoiceFin = {
    id: 'invoice_finance',
    type: 'group',
    children: [
        {
            id: 'invoice_finance_1',
            title: 'Invoice',
            type: 'item',
            url: '/invoice',
            icon: icons.RequestQuoteIcon,
        }
    ]
};

export default invoiceFin;